var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.64 9.19997C17.64 8.45998 17.58 7.91998 17.45 7.35999H9V10.6999H13.96C13.86 11.53 13.32 12.78 12.12 13.6199L12.1032 13.7318L14.7749 15.8015L14.96 15.82C16.66 14.25 17.64 11.94 17.64 9.19997Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 18C11.43 18 13.4699 17.2 14.96 15.82L12.12 13.62C11.36 14.15 10.34 14.52 8.99998 14.52C6.62 14.52 4.60001 12.95 3.87995 10.78L3.7744 10.789L0.996292 12.939L0.959961 13.04C2.43995 15.98 5.47995 18 8.99998 18Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87996 10.78C3.68997 10.22 3.58001 9.61992 3.58001 8.99995C3.58001 8.37991 3.68997 7.77994 3.86997 7.21994L3.86493 7.10068L1.05201 4.91614L0.959977 4.95991C0.350004 6.17993 0 7.54996 0 8.99995C0 10.4499 0.350004 11.8199 0.959977 13.0399L3.87996 10.78Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 3.47998C10.69 3.47998 11.8299 4.20997 12.48 4.82002L15.02 2.34C13.46 0.890004 11.4299 0 8.99998 0C5.47995 0 2.43995 2.01998 0.959961 4.95996L3.86995 7.21999C4.60001 5.05 6.62 3.47998 8.99998 3.47998Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.d2559390d9755535a22f20dcbaa6b94f.svg";
export { ForwardRef as ReactComponent };